

import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { verifyOTPAndSaveData } from "../redux/actions/userActions";
import config from "../config";

const Page2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    loading,
    error: reduxError,
    isAuthenticated,
  } = useSelector((state) => state.user);

  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [username, setUsername] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [askUsername, setAskUsername] = useState(false);
  const [error, setError] = useState("");
  const [courseType, setCourseType] = useState("");
  const [courseTypes, setCourseTypes] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [resendTimer, setResendTimer] = useState(0);

  // Fetch course types on component mount
  useEffect(() => {
    const fetchCourseTypes = async () => {
      try {
        let data;
        if (config.environment === "development") {
          data = await config.services.getTests();
        } else {
          const response = await fetch(
            `${config.baseUrl}${config.api.getTests}`
          );
          data = await response.json();
        }

        if (data.status && data.data) {
          setCourseTypes(data.data);
        } else {
          console.error("Failed to fetch course types:", data.message);
        }
      } catch (err) {
        console.error("Error fetching course types:", err);
      } finally {
        setLoadingCourses(false);
      }
    };

    fetchCourseTypes();
  }, []);

  // Add Bootstrap CSS
  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    // Add Bootstrap JS
    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);

  // Update local error state when Redux error changes
  useEffect(() => {
    if (reduxError) {
      setError(reduxError);
    }
  }, [reduxError]);

  useEffect(() => {
    let timerId;
    if (resendTimer > 0) {
      timerId = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerId);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timerId);
  }, [resendTimer]);

  const handleSendOTP = async () => {
    if (!mobile) {
      setError("Please enter your mobile number");
      return;
    }
    if (!courseType) {
      setError("Please select a course type");
      return;
    }

    setError("");

    try {
      let data;
      if (config.environment === "development") {
        data = await config.services.sendOtp(mobile, courseType);
      } else {
        const formData = new URLSearchParams();
        formData.append("action", "sendotp");
        formData.append("mobile", mobile);
        formData.append("courseType", courseType);

        const response = await fetch(`${config.baseUrl}${config.api.sendOtp}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formData,
        });
        data = await response.json();
      }

      if (data.status) {
        setShowOtp(true);
        setAskUsername(data.data?.username === true);
        setError("");
        setResendTimer(60); // start 60 seconds timer on sending OTP
      } else {
        setError(data.message || "Failed to send OTP");
      }
    } catch (err) {
      setError("Failed to send OTP. Please try again.");
      console.error("Error sending OTP:", err);
    }
  };

  const handleVerifyOTP = async () => {
    if (!otp) {
      setError("Please enter the OTP");
      return;
    }
    if (askUsername && !username) {
      setError("Please enter your username");
      return;
    }

    setError("");

    try {
      // Use Redux action to verify OTP and save data
      const result = await dispatch(
        verifyOTPAndSaveData(mobile, otp, courseType, username)
      );
      if (result && result.status) {
        // Check if the user has already completed the test
        if (result.data && result.data.testDone === true) {
          // Navigate to the test completed page
          navigate("/test-completed");
        }
        // If testUrl is provided and test is not done, navigate to the test page
        else if (result.data && result.data.testUrl) {
          navigate("/dashboard", { state: { testUrl: result.data.testUrl } });
        } else {
          navigate("/dashboard");
        }
      }
    } catch (err) {
      setError("Failed to verify OTP. Please try again.");
      console.error("Error verifying OTP:", err);
    }
  };

  return (
    <Box
      sx={{ fontFamily: "'Segoe UI', sans-serif", backgroundColor: "#f9fafd" }}
    >
      {/* Hero Section */}
      <Box
        // sx={{
        //   backgroundImage: 'url("/akash/images/03scholar_ibt.jpg")',
        //   backgroundRepeat: "no-repeat",
        //   backgroundSize: "contain",
        //   backgroundPosition: { xs: "top left 16%", md: "center" },
        //   backgroundColor: "#f8f9fa",
        //   width: "100%",
        //   position: "relative",
        //   margin: 0,
        //   padding: 0,
        // }
        //   sx={{
        //     backgroundImage: 'url("/akash/images/03scholar_ibt.jpg")',
        //     backgroundRepeat: "no-repeat",
        //     backgroundSize: { xs: "200% auto", md: "contain" },
        //     backgroundPosition: { xs: "top left 16%", md: "center" }, // move image more to left
        //     backgroundColor: "#f8f9fa",
        //     width: "100%",
        //     minHeight: { xs: "160px", md: "500px" },  // smaller height for mobile
        //     position: "relative",
        //     margin: 0,
        //     padding: 0,
        //     mt: 0, // remove top margin if any
        //     pt: 0, // remove top padding if any
        //   }}
        // // >
        // >

        //   <Container
        //     maxWidth={false}
        //     sx={{
        //       position: "relative",
        //       zIndex: 1,
        //       mt: "-73px",
        //       height: "100%",
        //       padding: { xs: "20px", md: "40px" },
        //     }}
        //   >
        sx={{
          backgroundImage: 'url("/akash/images/scholar.jpg")',
          backgroundRepeat: "no-repeat",
          // backgroundSize: { xs: "200% auto", md: "contain" },
          backgroundSize: { xs: "0", md: "contain" },
          backgroundPosition: { xs: "top left 19%", md: "center" },
          backgroundColor: "#f8f9fa",
          width: "100%",
          minHeight: { xs: "160px", md: "500px" },
          position: "relative",
          marginTop: { xs: 0, md: "-80px" },
          paddingTop: 0,
        }}
      >

        <Link
          href="#"
          sx={{
            color: "primary.main",
            fontSize: "smaller",
            fontWeight: "bold",
          }}
        >
          {/* How to register */}
        </Link>

        <Container
          maxWidth={false}
          sx={{
            position: "relative",
            zIndex: 1,
            height: "100%",
            padding: { xs: "20px", md: "40px" },
            marginTop: 0,
            paddingTop: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
            }}
          >
            {!isAuthenticated && (
              <Box
                sx={{
                  width: { xs: "100%", md: "33.33%" },
                  marginTop: { xs: "0", md: "20px" },
                }}
              >
                {/* Mobile-only animated banner */}
                <Box
                  sx={{
                    display: { xs: "block", md: "none" },
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    mb: 2,
                    color: "#fff",
                    // background: "linear-gradient(90deg, #ff5722 0%, #ff9800 100%)",
                    background: "#5C6BC0",
                    padding: "12px 20px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                    letterSpacing: "1px",
                  }}
                >
                  🎯 Lakshya Scholarship Test
                </Box>


                <Box
                  sx={{
                    backgroundColor: "#fff",
                    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
                    padding: "20px",
                    borderRadius: "10px 10px 0 0",
                    marginTop: { xs: "23px", md: "63px" },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "smaller",
                        textAlign: "center",
                      }}
                    >
                      Register Now
                    </Typography>
                    <Link
                      href="#"
                      sx={{
                        color: "primary.main",
                        fontSize: "smaller",
                        fontWeight: "bold",
                      }}
                    >
                      {/* How to register */}
                    </Link>
                  </Box>

                  {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      {error}
                    </Alert>
                  )}

                  <TextField
                    fullWidth
                    placeholder="Enter Mobile no"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    sx={{ mb: 1.5, fontSize: "smaller" }}
                  />
                  {showOtp && (
                    <>
                      {askUsername && (
                        <TextField
                          fullWidth
                          placeholder="Enter Username"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          sx={{ mb: 1.5, fontSize: "smaller" }}
                        />
                      )}
                      <TextField
                        fullWidth
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        sx={{ mb: 1.5, fontSize: "smaller" }}
                      />
                    </>
                  )}

                  <FormControl fullWidth sx={{ mb: 1.5 }}>
                    <Select
                      displayEmpty
                      value={courseType}
                      onChange={(e) => setCourseType(e.target.value)}
                      sx={{ fontSize: "smaller" }}
                      disabled={loadingCourses}
                    >
                      <MenuItem value="" disabled>
                        Select Course Type
                      </MenuItem>
                      {courseTypes.map((course) => (
                        <MenuItem key={course.id} value={course.id}>
                          {course.test_series_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Button
                    variant="contained"
                    fullWidth
                    sx={{ mt: 1.5 }}
                    onClick={showOtp ? handleVerifyOTP : handleSendOTP}
                    disabled={loading || loadingCourses}
                  >
                    {loading
                      ? "Please wait..."
                      : showOtp
                        ? "Verify"
                        : "Get OTP"}
                  </Button>
                  {showOtp && (
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{ mt: 1 }}
                    onClick={handleSendOTP}
                    disabled={loading || loadingCourses || resendTimer > 0}
                  >
                    {resendTimer > 0 ? `Resend OTP (${resendTimer}s)` : "Resend OTP"}
                  </Button>
                  )}
                </Box>

                <Box
                  sx={{
                    backgroundColor: "#ffc107",
                    color: "white",
                    padding: "10px",
                    textAlign: "center",
                    fontSize: "14px",
                    borderRadius: "0 0 20px 20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src="/akash/images/cnd.svg"
                    width="18"
                    style={{ marginRight: "8px" }}
                    alt="icon"
                  />
                  More than 1,24,350 Scholarships awarded last year
                </Box>
              </Box>
            )}
          </Box>
        </Container>
      </Box>

      {/* Test Details and Eligibility Section */}
      <Container sx={{ py: 5, mt: 4 }}>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column", // Stack vertically by default
            gap: 4,
            mt: "-90px",
            backgroundColor: "#fff",
            padding: "2rem",
            borderRadius: "10px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            justifyContent: "center", // Center the content horizontally
            alignItems: "center", // Center the content vertically
          }}
        >
          {/* Centered Test Details Typography */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              // mb: 1,
              color: "#2F5985",
              fontSize: "1.5rem",
              textAlign: "center", // Center the text horizontally
              width: "100%", // Ensure it spans across both columns
            }}
          >
            Test details
          </Typography>

          {/* First Box - Test details */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: { xs: "column", md: "row" }, // Stack vertically on small screens, row on large
              gap: 4,
              width: "100%", // Ensure it takes full width
            }}
          >
            <Box
              sx={{
                backgroundColor: "#f0f8ff",
                padding: "2rem",
                borderRadius: "10px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                width: "100%", // Full width on small screens
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "1rem",
                  padding: "1rem 0",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <img
                  src="/akash/images/online-icon1.svg"
                  style={{ width: "40px", height: "40px", minWidth: "40px" }}
                  alt="Online mode"
                />
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ margin: 0, fontWeight: 600, color: "#2F5985" }}
                  >
                    Online mode
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
                    Available on mobile and desktop
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "1rem",
                  padding: "1rem 0",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <img
                  src="/akash/images/watch-icon3.svg"
                  style={{ width: "40px", height: "40px", minWidth: "40px" }}
                  alt="Time"
                />
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ margin: 0, fontWeight: 600, color: "#2F5985" }}
                  >
                    24/7 test available
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
                    Available on all days (Monday to Sunday)
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "1rem",
                  padding: "1rem 0",
                }}
              >
                <img
                  src="/akash/images/time-icon2.svg"
                  style={{ width: "40px", height: "40px", minWidth: "40px" }}
                  alt="Duration"
                />
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ margin: 0, fontWeight: 600, color: "#2F5985" }}
                  >
                    Pause & Resume test options 
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
                    An option to freely pause and resume test any time
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Second Box - Eligibility Criteria */}
            <Box
              sx={{
                backgroundColor: "#f0f8ff",
                padding: "2rem",
                borderRadius: "10px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                width: "100%", // Full width on small screens
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "1rem",
                  padding: "1rem 0",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <img
                  src="/akash/images/eight-iocn-4.svg"
                  style={{ width: "40px", height: "40px" }}
                  alt="Class 6th to 12th"
                />
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ margin: 0, fontWeight: 600, color: "#2F5985" }}
                  >
                    Classes 7th to 12th students
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    All state boards, CBSE, and ICSE/ISC students are eligible for LST test
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "1rem",
                  padding: "1rem 0",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <img
                  src="/akash/images/answerkey.png"
                  style={{ width: "40px", height: "40px" }}
                  alt="Answer key available"
                />
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ margin: 0, fontWeight: 600, color: "#2F5985" }}
                  >
                    Answer key available
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    A facility to verify the answers after the test.
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "1rem",
                  padding: "1rem 0",
                }}
              >
                <img
                  src="/akash/images/question.png"
                  style={{ width: "40px", height: "40px" }}
                  alt="Class 12th passed"
                />
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ margin: 0, fontWeight: 600, color: "#2F5985" }}
                  >
                    Real exam-based questions
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    Questions are taken from previous year exams
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>








        {/* Banner Box */}
        <Box
          sx={{
            backgroundColor: "#ffc107",
            color: "white",
            padding: "10px 10px",
            position: "relative",
            marginTop: "2.5rem",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
         <Typography
  variant="h6"
  sx={{
    fontSize: { xs: '12px', md: '20px' },
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    wordBreak: 'break-word'
  }}
>
  LST Scholarship(s) are
  <Box
    component="span"
    sx={{
      display: { xs: 'block', md: 'inline' }
    }}
  >
    valid for <strong>30 days only.</strong>
  </Box>
</Typography>

          <img
            src="/akash/images/download.png"
            alt="calendar"
            style={{
              position: "absolute",
              right: 0,
              height: "60px",
              bottom: 0,
            }}
          />
        </Box>

        {/* How to Register Box */}
        <Box
          sx={{
            backgroundImage: 'url("/akash/images/ibt.jpg")',
            padding: "2rem",
            borderRadius: "20px",
            marginTop: "1.5rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                textAlign: { xs: "center", md: "right" },
                mb: { xs: 3, md: 0 },
              }}
            >
              <img
                src="/akash/images/model-registerstep.5abccbb1.png"
                alt="girl illustration"
                style={{ maxWidth: "100%" }}
              />
            </Box>
            <Box sx={{ width: { xs: "100%", md: "50%" } }}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: "2rem",
                  borderRadius: "10px",
                  width: "100%",
                  maxWidth: "500px",
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  How to register?
                </Typography>
                <Typography sx={{ mb: 2 }}>In just 3-step process</Typography>
                <Box component="ol" sx={{ paddingLeft: "1rem" }}>
                  <Box component="li" sx={{ mb: 1 }}>
                    Enter mobile number

                  </Box>
                  <Box component="li" sx={{ mb: 1 }}>
                    Chose the test
                  </Box>
                  <Box component="li" sx={{ mb: 1 }}>
                    Verify OTP and go ahead.
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>

      {/* Scholarship Stats */}
      <Box sx={{ textAlign: "center", py: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "30px",
            padding: "20px",
          }}
        >
          <Box sx={{ textAlign: "left" }}>
            <Typography
              variant="h4"
              sx={{ margin: 0, fontSize: "32px", color: "#4db0ff" }}
            >
              1,24,350+
            </Typography>
            <Typography
              sx={{
                margin: "5px 0 0 0",
                fontSize: "22px",
                fontWeight: "bold",
                lineHeight: 1.4,
              }}
            >
              Scholarships
              <br />
              awarded last year
            </Typography>
          </Box>
          <Box>
            <img
              src="/akash/images/scho_digiticon.69a6a8ff (1).svg"
              alt="Scholarship Certificate"
              style={{ width: "80px" }}
            />
          </Box>
        </Box>
      </Box>

      {/* FAQ Section */}
      <Box sx={{ py: 5, backgroundColor: "white" }}>
        <Container>
          <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold" }}>
            Frequently asked questions
          </Typography>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography>What is LST and what does it offer?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                It offers instant admission and up to 100% scholarship.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <Typography>Who is eligible to appear for LST?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Students from class 7th to 12th and those who have completed 12th class, are eligible..
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              <Typography>Is there any fee for LST?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>There is no fee to take the test.</Typography>
            </AccordionDetails>
          </Accordion>

          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ fontSize: "small" }}>
              In case of any issue,  contact: 8503887038 | Email:
              <Link href="mailto:lakshyajalandhar1@gmail.com">
                lakshyajalandhar1@gmail.com
              </Link>
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Page2; 
